"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledIs = _interopRequireDefault(require("styled-is"));

var _Toast = _interopRequireDefault(require("./Toast"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    animation: ", " 0.3s ease-in forwards;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    animation: ", " 0.4s ease-out;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    visibility: hidden;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  max-width: 100%;\n  padding-bottom: 8px;\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -", "px);\n\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 16px;\n  right: 16px;\n  bottom: 8px;\n  z-index: 9999;\n\n  @media (min-width: 500px) {\n    left: 30px;\n    right: 30px;\n    bottom: 22px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: translate(0, 0);\n  }\n  to {\n    transform: translate(-500px, 0);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: translate(0, 1000px);\n  }\n  to {\n    transform: translate(0, 0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LIMIT = 3;
var HIDE_TIMEOUT = 7000;
var HIDE_LEAVE_TIMEOUT = 5000;
var fromBottomAnimation = (0, _styledComponents.keyframes)(_templateObject());
var toLeftAnimation = (0, _styledComponents.keyframes)(_templateObject2());

var Wrapper = _styledComponents["default"].div(_templateObject3());

var ToastContainer = _styledComponents["default"].div(_templateObject4(), function (_ref) {
  var bottomOffset = _ref.bottomOffset;
  return bottomOffset;
}, (0, _styledIs["default"])('isInvisible')(_templateObject5()));

var ToastWrapper = _styledComponents["default"].div(_templateObject6(), (0, _styledIs["default"])('isAppearing')(_templateObject7(), fromBottomAnimation), (0, _styledIs["default"])('isHiding')(_templateObject8(), toLeftAnimation));

var instance;

function addToast(params) {
  if (!instance) {
    throw new Error('ToastsManager is not mounted');
  }

  setTimeout(function () {
    instance.addToast(params);
  }, 0);
}
/**
 * Компонент довольно сильно усложнен для поддержки красивых анимаций тостов
 */


var ToastsManager =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ToastsManager, _PureComponent);

  function ToastsManager() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ToastsManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ToastsManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "lastId", 0);

    _defineProperty(_assertThisInitialized(_this), "toastsRefs", {});

    _defineProperty(_assertThisInitialized(_this), "hideTimeouts", []);

    _defineProperty(_assertThisInitialized(_this), "clearingTimeouts", []);

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentToasts: [],
      delayedQueue: [],
      heights: {},
      bottomOffsets: {},
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "onCloseClick", function (id) {
      _this.startToastsHiding(id);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.setState({
        isHovered: true
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this.hideTimeouts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var id = _step.value;
          clearTimeout(id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onLeave", function () {
      var currentToasts = _this.state.currentToasts;

      _this.setState({
        isHovered: false
      });

      if (!currentToasts.length) {
        return;
      }

      var hideIds = new Set(currentToasts.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      }));
      var timeoutId = setTimeout(function () {
        _this.startToastsHiding(hideIds);
      }, HIDE_LEAVE_TIMEOUT);

      _this.hideTimeouts.push(timeoutId);
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      _this.checkHeights();
    });

    return _this;
  }

  _createClass(ToastsManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      instance = this;
      window.addEventListener('blur', this.onLeave);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var currentToasts = this.state.currentToasts;
      var prevLength = prevState.currentToasts.length;

      if (currentToasts.length && !prevLength) {
        window.addEventListener('resize', this.onResize);
      } else if (!currentToasts.length && prevLength) {
        window.removeEventListener('resize', this.onResize);
      }

      this.checkHeights();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (instance === this) {
        instance = null;
      }

      window.removeEventListener('blur', this.onLeave);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.hideTimeouts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var id = _step2.value;
          clearTimeout(id);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.clearingTimeouts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _id = _step3.value;
          clearTimeout(_id);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: "getActiveToastsCount",
    value: function getActiveToastsCount() {
      var currentToasts = this.state.currentToasts;
      return currentToasts.filter(function (toast) {
        return !toast.isHiding;
      }).length;
    }
  }, {
    key: "checkDelayedQueue",
    value: function checkDelayedQueue() {
      var _this2 = this;

      var delayedQueue = this.state.delayedQueue;

      if (delayedQueue.length && this.getActiveToastsCount() < LIMIT) {
        var _delayedQueue = _toArray(delayedQueue),
            firstToast = _delayedQueue[0],
            other = _delayedQueue.slice(1);

        this.setState({
          delayedQueue: other
        }, function () {
          _this2.checkDelayedQueue();
        });
        this.showToast(firstToast);
      }
    }
  }, {
    key: "startToastsHiding",
    value: function startToastsHiding(ids) {
      var _this3 = this;

      if (!(ids instanceof Set)) {
        // eslint-disable-next-line no-param-reassign
        ids = new Set([ids]);
      }

      var currentToasts = this.state.currentToasts;
      this.setState({
        currentToasts: currentToasts.map(function (toast) {
          if (ids.has(toast.id)) {
            return _objectSpread({}, toast, {
              isHiding: true
            });
          }

          return toast;
        })
      }, function () {
        _this3.checkDelayedQueue();
      });
      this.clearingTimeouts.push(setTimeout(function () {
        _this3.removeToasts(ids);
      }, 400));
    }
  }, {
    key: "addToast",
    value: function addToast(toastParams) {
      var delayedQueue = this.state.delayedQueue;

      if (this.getActiveToastsCount() >= LIMIT) {
        this.setState({
          delayedQueue: delayedQueue.concat(toastParams)
        });
        return;
      }

      this.showToast(toastParams);
    }
  }, {
    key: "showToast",
    value: function showToast(_ref3) {
      var type = _ref3.type,
          text = _ref3.text,
          renderer = _ref3.renderer;
      var _this$state = this.state,
          currentToasts = _this$state.currentToasts,
          isHovered = _this$state.isHovered;
      this.lastId += 1;
      var id = this.lastId;
      this.toastsRefs[id] = (0, _react.createRef)();

      if (!isHovered) {
        this.startToastHideTimeout(id);
      }

      this.setState({
        currentToasts: currentToasts.concat({
          id: id,
          type: type,
          text: text,
          renderer: renderer
        })
      });
    }
  }, {
    key: "removeToasts",
    value: function removeToasts(ids) {
      var currentToasts = this.state.currentToasts;
      this.setState({
        currentToasts: currentToasts.filter(function (toast) {
          return !ids.has(toast.id);
        })
      });
    }
  }, {
    key: "calcOffsets",
    value: function calcOffsets(heights) {
      var _this$state2 = this.state,
          currentToasts = _this$state2.currentToasts,
          bottomOffsets = _this$state2.bottomOffsets;
      var newBottomOffsets = {};
      var totalOffset = 0;

      for (var i = currentToasts.length - 1; i >= 0; i -= 1) {
        var _currentToasts$i = currentToasts[i],
            id = _currentToasts$i.id,
            isHiding = _currentToasts$i.isHiding;

        if (isHiding) {
          newBottomOffsets[id] = bottomOffsets[id];
        } else {
          var height = heights[id];
          var bottomOffset = void 0;

          if (height) {
            bottomOffset = totalOffset;
            totalOffset += height;
          } else {
            // TODO:
            bottomOffset = 0;
          }

          newBottomOffsets[id] = bottomOffset;
        }
      }

      this.setState({
        heights: heights,
        bottomOffsets: newBottomOffsets
      });
    }
  }, {
    key: "checkHeights",
    value: function checkHeights() {
      var _this4 = this;

      var _this$state3 = this.state,
          currentToasts = _this$state3.currentToasts,
          heights = _this$state3.heights;
      var newHeights = {};
      var heightsUpdated = false;

      var _loop = function _loop() {
        var id = _Object$keys[_i];
        var ref = _this4.toastsRefs[id];

        if (ref.current) {
          var toast = currentToasts.find(function (toast) {
            return toast.id === Number(id);
          });
          var height = toast.isHiding ? 0 : ref.current.clientHeight;
          newHeights[id] = height;

          if (heights[id] === undefined || heights[id] !== height) {
            heightsUpdated = true;
          }
        }
      };

      for (var _i = 0, _Object$keys = Object.keys(this.toastsRefs); _i < _Object$keys.length; _i++) {
        _loop();
      }

      if (heightsUpdated) {
        this.calcOffsets(newHeights);
      }
    }
  }, {
    key: "startToastHideTimeout",
    value: function startToastHideTimeout(id) {
      var _this5 = this;

      var timeoutId = setTimeout(function () {
        _this5.startToastsHiding(id);
      }, HIDE_TIMEOUT);
      this.hideTimeouts.push(timeoutId);
    }
  }, {
    key: "renderToasts",
    value: function renderToasts() {
      var _this6 = this;

      var renderToast = this.props.renderToast;
      var _this$state4 = this.state,
          currentToasts = _this$state4.currentToasts,
          bottomOffsets = _this$state4.bottomOffsets;
      return currentToasts.map(function (_ref4) {
        var id = _ref4.id,
            type = _ref4.type,
            text = _ref4.text,
            renderer = _ref4.renderer,
            isHiding = _ref4.isHiding;
        var bottomOffset = bottomOffsets[id];
        var isOffsetCalculated = bottomOffset !== undefined;
        var render = renderer || renderToast;
        return _react["default"].createElement(ToastContainer, {
          key: id,
          ref: _this6.toastsRefs[id],
          isInvisible: !isOffsetCalculated,
          bottomOffset: bottomOffset
        }, _react["default"].createElement(ToastWrapper, {
          isAppearing: isOffsetCalculated,
          isHiding: isHiding
        }, render ? render({
          type: type,
          text: text,
          onClose: function onClose() {
            return _this6.onCloseClick(id);
          }
        }) : _react["default"].createElement(_Toast["default"], null, text)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(Wrapper, {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onLeave
      }, this.renderToasts());
    }
  }], [{
    key: "info",
    value: function info(text) {
      addToast({
        type: 'info',
        text: text
      });
    }
  }, {
    key: "warn",
    value: function warn(text) {
      addToast({
        type: 'warn',
        text: text
      });
    }
  }, {
    key: "error",
    value: function error(text) {
      addToast({
        type: 'error',
        text: text
      });
    }
  }, {
    key: "show",
    value: function show(renderer) {
      addToast({
        type: 'component',
        renderer: renderer
      });
    }
  }]);

  return ToastsManager;
}(_react.PureComponent);

exports["default"] = ToastsManager;

_defineProperty(ToastsManager, "propTypes", {
  renderToast: _propTypes["default"].func
});

_defineProperty(ToastsManager, "defaultProps", {
  renderToast: null
});